type FrameSettingsProperty = {
  enabled?: boolean;
  scaleY?: number;
  scaleX?: number;
  shiftY?: number;
  shiftX?: number;
  shiftZ?: number;
  rotateY?: number;
  rotateZ?: number;
  scalingHorizontalShift?: number;
  scalingVerticalShift?: boolean;
  scalingVerticalShiftValue?: number;
  color?: string;
  recalculateHingePos?: boolean;
};

export interface RailSettings {
  scaleY?: number;
  scaleX?: number;
  shiftY?: number;
  shiftX?: number;
  shiftZ?: number;
  generalRailShiftY?: number;
  generalRailScaleX?: number;
}

type KozijnSettingsProperty = {
  enabled?: boolean;
  scaleY?: number;
};

type LockSettingsProperty = {
  enabled?: boolean;
};

export interface frameSettings {
  frameHeight?: number;
  frameBottom?: FrameSettingsProperty;
  frameLeft?: FrameSettingsProperty;
  frameRight?: FrameSettingsProperty;
  frameTop?: FrameSettingsProperty;
  misc0?: FrameSettingsProperty;
  misc1?: FrameSettingsProperty;
  hingeTop?: FrameSettingsProperty;
  hingeBottom?: FrameSettingsProperty;
  generalShiftZ?: number;
  generalScaleX?: number;
  generalShiftY?: number;
  JHandleReverse?: boolean;
  generalScaleY?: number;
  JhandleShiftZ?: number;
  JhandleShiftX?: number;
  generalShiftElementsY?: number;
  UHandleReverse?: boolean;
  UHandleShiftX?: number;
  allScaleY?: number;
  addFrameScaleY?: number;
  JhandleGeneralShiftZ?: number;
  JhandleGeneralRotationY?: number;
  UHandleReversePos?: boolean;
  JhandleGeneralShiftY?: number;
  schuifdeurHandleShift?: boolean;
  KomHandleGeneralShiftZ?: number;
  KomHandleShow?: boolean;
  UHandleShowBackHandle?: boolean;
  KomHandleGeneralRotationY?: number;
  generalGlassScaleY?: number;
  KomHandleGeneralPositionX?: number;
  UHandleShowFrontHandle?: boolean;
}

export interface kozijnSettings {
  kozijnLeft?: KozijnSettingsProperty;
  kozijnRight?: KozijnSettingsProperty;
  kozijnTop?: KozijnSettingsProperty;
  rotateKozijn?: boolean;
}

export interface lockSettings {
  handleSlotkastBody?: LockSettingsProperty;
  rotateHandleSlotkast?: number;
  rotateLock?: number;
}

export interface DoorSettings {
  main?: {
    frameSettings?: frameSettings;
    kozijnSettings?: kozijnSettings;
    railSettings?: RailSettings;
    lockSettings?: lockSettings;
  };
  secondary?: {
    frameSettings?: frameSettings;
    kozijnSettings?: kozijnSettings;
    railSettings?: RailSettings;
    lockSettings?: lockSettings;
  };
  tertiary?: {
    frameSettings?: frameSettings;
    kozijnSettings?: kozijnSettings;
    railSettings?: RailSettings;
    lockSettings?: lockSettings;
  };
  quaternary?: {
    frameSettings?: frameSettings;
    kozijnSettings?: kozijnSettings;
    railSettings?: RailSettings;
    lockSettings?: lockSettings;
  };
}

const doorSettings: Record<string, DoorSettings> = {
  opdekdeurmetkozijn: {
    main: {
      kozijnSettings: {
        rotateKozijn: true,
      },
    },
  },
  opdekdeur: {
    main: {
      kozijnSettings: {
        rotateKozijn: true,
      },
    },
  },
  stompedeur: {
    main: {
      kozijnSettings: {
        rotateKozijn: true,
      },
    },
  },
  schuifdeur: {
    main: {
      frameSettings: {
        generalScaleY: 0.992,
        generalShiftY: 0,
        generalShiftElementsY: -0.01,
        frameRight: {
          scaleX: 0.3,
          shiftX: -0.13,
        },
        frameLeft: {
          scaleX: 0.25,
          shiftX: 0.1145,
        },
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.32,
      },
    },
  },
  taatsdeur: {
    main: {
      frameSettings: {
        frameHeight: 3000,
        frameTop: {
          shiftY: -0.027,
        },
        frameBottom: {
          shiftY: 0.005,
        },
        frameLeft: {
          shiftY: 0.005,
          scaleY: -0.013,
          scaleX: 0.25,
          shiftX: 0.106,
        },
        frameRight: {
          shiftY: 0.005,
          scaleY: -0.013,
          scaleX: 0.25,
          shiftX: -0.106,
        },
      },
    },
  },
  paneel: {
    main: {
      frameSettings: {
        generalScaleY: 0.98,
      },
    },
  },
  scharnierdeur: {
    main: {
      frameSettings: {
        generalScaleY: 0.9791,
        UHandleReversePos: false,
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
  },
  paneelpaneel: {},
  paneelpaneelpaneel: {},
  paneelpaneelpaneelpaneel: {},
  dubbel: {
    main: {
      frameSettings: {
        JhandleGeneralRotationY: Math.PI,
        JHandleReverse: true,
      },
    },
  },
  dubbel1paneel: {
    main: {
      frameSettings: {
        frameHeight: 3020,
        generalScaleY: 1.009,
        JHandleReverse: true,
        JhandleGeneralRotationY: Math.PI,
      },
    },
    secondary: {
      frameSettings: {
        frameHeight: 3020,
        generalScaleY: 1.009,
        JhandleShiftX: 0.011,
      },
    },
    tertiary: {
      frameSettings: {},
    },
  },

  dubbel2paneel: {
    main: {
      frameSettings: {
        JHandleReverse: true,
        UHandleReverse: true,
        generalScaleY: 1.006,
        generalScaleX: 1.05,

        misc0: {
          rotateY: Math.PI,
        },
        misc1: {
          rotateY: Math.PI,
        },
      },
    },
    secondary: {
      frameSettings: {
        generalScaleY: 1.006,
        JhandleShiftX: 0.02,
        UHandleShiftX: 0.03,
        frameLeft: {
          shiftX: 0.02,
        },
      },
    },
  },
  taatsdeurtaatsdeurpaneelpaneel: {
    main: {
      frameSettings: {
        generalScaleY: 1.0075,
        JhandleShiftZ: -0.025,
        JhandleShiftX: -0.02,
      },
    },
    secondary: {
      frameSettings: {
        generalScaleY: 1.0075,
        UHandleShiftX: 0.03,
      },
    },
  },
  taatsdeurpaneelpaneel: {
    main: {
      frameSettings: {
        JHandleReverse: true,
        JhandleGeneralRotationY: Math.PI,
        frameTop: {
          shiftY: 0.02,
        },
        frameRight: {
          scaleY: 0.007,
        },
        frameLeft: {
          scaleY: 0.0088,
        },
      },
    },
  },
  taatsdeur2paneel: {
    main: {
      frameSettings: {
        JhandleShiftX: 0.028,
        JhandleGeneralShiftZ: 0.095,
        frameTop: {
          shiftY: 0.02,
        },
        frameRight: {
          scaleY: 0.0034,
        },
        frameLeft: {
          scaleY: 0.005,
        },
      },
    },
  },
  taatsdeur1paneel: {
    main: {
      frameSettings: {
        JHandleReverse: true,
        JhandleGeneralRotationY: Math.PI,

        // generalScaleY: 0.9935,
      },
    },
    secondary: {
      frameSettings: {
        generalScaleY: 0.9858,
      },
    },
  },
  schuifdeurpaneelpaneel: {
    main: {
      frameSettings: {
        frameTop: {
          shiftY: 0.0085,
        },
        frameRight: {
          scaleY: 0.0023,
        },
        frameLeft: {
          scaleY: 0.005,
        },
      },
    },
  },
  schuifdeurpaneelpaneelschuifdeur: {
    main: {
      frameSettings: {
        generalScaleY: 0.984,
        frameLeft: {
          scaleY: 0.005,
        },
        frameRight: {
          scaleY: 0.005,
        },
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.33,
      },
    },
    quaternary: {
      frameSettings: {
        KomHandleGeneralShiftZ: -0.01,
        KomHandleShow: false,
        generalScaleY: 0.984,
        schuifdeurHandleShift: false,
        UHandleShiftX: 0.04,
        UHandleShowBackHandle: false,
        frameLeft: {
          scaleY: 0.01,
        },
        frameRight: {
          scaleY: 0.005,
        },
        frameTop: {
          scaleY: 1.4,
          shiftY: -1.018,
        },
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.33,
      },
    },
    secondary: {
      frameSettings: {
        allScaleY: 0.9865,
      },
    },
  },
  schuifdeurschuifdeurpaneelpaneel: {
    main: {
      frameSettings: {
        UHandleReversePos: true,
        schuifdeurHandleShift: false,
        KomHandleGeneralShiftZ: -0.035,
        KomHandleShow: false,
        KomHandleGeneralRotationY: Math.PI,
        UHandleShiftX: -0.02,
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.3,
      },
    },
  },
  schuifdeurpaneelschuifdeur: {
    main: {
      railSettings: {
        scaleY: 2,
        shiftY: -2.59,
      },
      frameSettings: {},
    },
    secondary: {
      frameSettings: {
        schuifdeurHandleShift: false,
        UHandleShiftX: 0.035,
        UHandleShowBackHandle: false,
        KomHandleGeneralShiftZ: -0.02,
        KomHandleShow: false,
      },
      railSettings: {
        scaleY: 2,
        shiftY: -2.59,
      },
    },
  },
  schuifpaneelschuiftrap: {
    main: {
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.3,
      },
    },
    secondary: {
      frameSettings: {
        schuifdeurHandleShift: false,
        UHandleShiftX: 0.035,
        UHandleShowBackHandle: false,
        KomHandleGeneralShiftZ: -0.02,
        KomHandleShow: false,
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.3,
      },
    },
  },
  dubbeleschuifdeur1paneel: {
    main: {
      frameSettings: {
        generalScaleY: 0.984,
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.34,
      },
    },
    secondary: {
      frameSettings: {
        generalScaleY: 0.984,
        schuifdeurHandleShift: false,
        UHandleShiftX: 0.035,
        UHandleShowBackHandle: false,
        KomHandleGeneralShiftZ: -0.02,
        KomHandleShow: false,
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.34,
      },
    },
    tertiary: {
      frameSettings: {
        allScaleY: 0.99,
      },
    },
  },
  dubbeleschuifdeur2paneel: {
    main: {
      frameSettings: {
        misc0: {
          scaleY: 0.7,
          shiftY: -1.58,
        },
      },
    },
    secondary: {
      frameSettings: {
        schuifdeurHandleShift: false,
        generalGlassScaleY: 1.03,
        UHandleShiftX: 0.035,
        UHandleShowBackHandle: false,
        KomHandleGeneralShiftZ: -0.02,
        KomHandleShow: false,
        frameTop: {
          scaleY: 2.3,
          shiftY: -3.335,
        },
        generalShiftZ: -0.067,
        generalScaleX: 1.01,
        // generalShiftY: -0.005,
      },
      railSettings: {
        generalRailShiftY: 0.045,
        generalRailScaleX: 1.012,
        scaleY: 3.05,
        shiftY: -5.32,
      },
    },
    tertiary: {
      frameSettings: {
        generalGlassScaleY: 1.03,
        frameTop: {
          scaleY: 2.3,
          shiftY: -3.335,
        },
        generalShiftZ: 0.067,
        generalScaleX: 1.01,
        // generalShiftY: -0.005,
      },
      railSettings: {
        generalRailShiftY: 0.045,
        generalRailScaleX: 1.012,
        scaleY: 3.05,
        shiftY: -5.32,
      },
    },
    quaternary: {
      frameSettings: {
        misc0: {
          scaleY: 0.7,
          shiftY: -1.58,
        },
      },
    },
  },
  dubbeleschuifdeur: {
    main: {
      frameSettings: {
        generalScaleY: 0.985,
        schuifdeurHandleShift: false,
        UHandleShiftX: 0.05,
        KomHandleGeneralShiftZ: -0.02,
        KomHandleShow: false,
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.329,
      },
    },
    secondary: {
      frameSettings: {
        generalScaleY: 0.985,
      },
      railSettings: {
        scaleY: 3.05,
        shiftY: -5.329,
      },
    },
  },
  schuifdeur2paneel: {
    main: {
      frameSettings: {
        generalScaleY: 0.985,
        misc0: {
          scaleY: 0.7,
          shiftY: -1.6,
        },
      },
    },
    secondary: {
      frameSettings: {
        schuifdeurHandleShift: false,
        UHandleShiftX: 0.05,
        KomHandleGeneralShiftZ: -0.03,
        KomHandleGeneralPositionX: -0.012,
        KomHandleShow: false,
        frameTop: {
          scaleY: 2.9,
          shiftY: -4.865,
        },
        generalShiftZ: -0.067,
        generalScaleX: 1.01,
        addFrameScaleY: 0.98,
      },
      railSettings: {
        // generalRailShiftY: 0.0,
        generalRailScaleX: 1.015,
        scaleY: 3.05,
        shiftY: -5.32,
      },
    },

    tertiary: {
      frameSettings: {
        generalScaleY: 0.985,
        misc0: {
          scaleY: 0.7,
          shiftY: -1.6,
        },
      },
    },
  },
  schuifdeur1paneel: {
    main: {
      frameSettings: {
        schuifdeurHandleShift: false,
        UHandleShiftX: 0.05,
        KomHandleGeneralShiftZ: -0.03,
        KomHandleGeneralPositionX: 0.005,
        UHandleShowBackHandle: false,
        KomHandleShow: false,
      },

      railSettings: {
        scaleY: 2,
        shiftY: -2.593,
      },
    },
    secondary: {
      frameSettings: {},
    },
  },
  scharnierdeur1paneel: {
    main: {
      frameSettings: {
        JhandleShiftX: 0.015,
        UHandleReversePos: false,
        UHandleShowFrontHandle: true,
        UHandleShiftX: -0.02,
        frameTop: {
          scaleY: 2.1,
          shiftY: -2.812,
        },
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
    secondary: {
      frameSettings: {
        frameLeft: {
          enabled: false,
        },
        misc0: {
          scaleY: 0.39,
          shiftY: -0.885,
        },
      },
    },
  },
  scharnierdeur2paneel: {
    main: {
      frameSettings: {
        JhandleShiftX: 0.01,
        UHandleReversePos: false,
        UHandleShowFrontHandle: true,
        UHandleShiftX: -0.02,
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
  },
  dubbelescharnierdeur: {
    main: {
      frameSettings: {
        UHandleReversePos: false,
      },
      kozijnSettings: {
        kozijnRight: {
          enabled: false,
        },
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
    secondary: {
      frameSettings: {
        hingeTop: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
        hingeBottom: {
          recalculateHingePos: true,
          shiftZ: -0.013,
        },
      },
      kozijnSettings: {
        kozijnLeft: {
          enabled: false,
        },
      },
      lockSettings: {
        handleSlotkastBody: {
          enabled: false,
        },
      },
    },
  },
  dubbelescharnierdeur1paneel: {
    main: {
      frameSettings: {
        UHandleReverse: true,
        generalScaleX: 1.02,
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
      kozijnSettings: {
        kozijnRight: {
          enabled: false,
        },
      },
    },
    secondary: {
      lockSettings: {
        handleSlotkastBody: {
          enabled: false,
        },
      },
      kozijnSettings: {
        kozijnLeft: {
          enabled: false,
        },
      },
      frameSettings: {
        generalScaleX: 1.03,
        hingeTop: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
        hingeBottom: {
          recalculateHingePos: true,
          shiftZ: -0.013,
        },
      },
    },
  },
  dubbelescharnierdeur2paneel: {
    main: {
      frameSettings: {
        allScaleY: 1.003,
      },
    },
    quaternary: {
      frameSettings: {
        allScaleY: 1.003,
      },
    },
    secondary: {
      lockSettings: {
        handleSlotkastBody: {
          enabled: false,
        },
      },
      frameSettings: {
        hingeTop: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
        hingeBottom: {
          recalculateHingePos: true,
          shiftZ: -0.013,
        },
      },
      kozijnSettings: {
        kozijnLeft: {
          scaleY: 0.998,
        },
      },
    },
    tertiary: {
      frameSettings: {
        UHandleReverse: true,
      },
      kozijnSettings: {
        kozijnRight: {
          scaleY: 0.998,
        },
      },
    },
  },
  scharnierdeurpaneelscharnierdeur: {
    main: {
      frameSettings: {
        JhandleGeneralRotationY: Math.PI,
        JHandleReverse: true,
        JhandleGeneralShiftZ: -0.25,
        JhandleShiftX: 0.037,
        UHandleReversePos: false,
        UHandleShowBackHandle: false,
        frameTop: {
          scaleY: 2.1,
          shiftY: -2.812,
        },
        hingeTop: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
        hingeBottom: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
      },
      kozijnSettings: {
        kozijnLeft: {
          enabled: false,
        },
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
    secondary: {
      frameSettings: {
        misc0: {
          scaleY: 0.39,
          shiftY: -0.89,
        },
      },
    },
    tertiary: {
      frameSettings: {
        UHandleReversePos: false,
        // UHandleShowBackHandle: false,
        UHandleShowFrontHandle: true,
        UHandleShiftX: -0.05,
        frameTop: {
          scaleY: 2.1,
          shiftY: -2.812,
        },
      },
      kozijnSettings: {
        kozijnRight: {
          enabled: false,
        },
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
  },
  scharnierpaneelscharniertrap: {
    main: {
      frameSettings: {
        JhandleShiftX: 0.02,
        UHandleReversePos: false,

        UHandleShowFrontHandle: true,
        frameTop: {
          scaleY: 2.1,
          shiftY: -2.812,
        },
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
    secondary: {
      frameSettings: {
        misc0: {
          scaleY: 0.5,
          scaleX: -0.08,
          shiftY: -1.139,
          shiftX: 0.003,
        },
      },
    },
    tertiary: {
      frameSettings: {
        UHandleReversePos: false,
        UHandleShowBackHandle: false,
        JhandleGeneralRotationY: Math.PI,
        JHandleReverse: true,
        JhandleShiftX: -0.03,
        UHandleShiftX: 0.035,
        frameTop: {
          scaleY: 2.1,
          shiftY: -2.812,
        },
        hingeTop: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
        hingeBottom: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
  },
  scharnierdeurpaneelpaneel: {
    main: {
      lockSettings: {
        rotateLock: Math.PI,
        rotateHandleSlotkast: 0,
      },
      frameSettings: {
        JhandleGeneralRotationY: Math.PI,
        JhandleShiftX: 0.017,
      },
    },
  },
  scharnierdeurpaneelpaneelscharnierdeur: {
    main: {
      frameSettings: {
        // UHandleShowFrontHandle: true,
        UHandleShowBackHandle: false,
        UHandleShiftX: -0.03,
        JhandleShiftX: 0.019,
        JhandleGeneralRotationY: Math.PI,
      },
      lockSettings: {
        rotateLock: Math.PI,
        rotateHandleSlotkast: 0,
      },
    },
    tertiary: {
      frameSettings: {
        UHandleShowFrontHandle: true,
        UHandleShiftX: -0.08,
        JhandleShiftX: -0.02,
        JHandleReverse: true,

        hingeTop: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
        hingeBottom: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
      },
      lockSettings: {
        rotateLock: Math.PI,
        rotateHandleSlotkast: 0,
      },
    },
  },
  scharnierdeurscharnierdeurpaneelpaneel: {
    main: {
      frameSettings: {
        JhandleShiftX: 0.017,
        UHandleReversePos: false,
        UHandleShiftX: -0.015,
        UHandleShowFrontHandle: true,
      },
      lockSettings: {
        rotateHandleSlotkast: 0,
      },
    },
    secondary: {
      lockSettings: {
        handleSlotkastBody: {
          enabled: false,
        },
      },
      frameSettings: {
        hingeTop: {
          recalculateHingePos: true,
          shiftZ: -0.005,
        },
        hingeBottom: {
          recalculateHingePos: true,
          shiftZ: -0.013,
        },
      },
    },
  },
};

export const useDoorSettings = () => {
  const getDoorSettings = (setting: string | undefined): DoorSettings => {
    return setting ? doorSettings[setting] : {};
  };

  return { getDoorSettings };
};
